import type { PreEnrollmentValidationError } from "@repo/models";

import { useQuery } from "@tanstack/react-query";

import type { PreEnrollmentValidationFilter } from "./types";

import PreEnrollmentValidationApi, { controller } from "../../api/preEnrollmentValidationApi";
import { TLPGrid } from "../../components/tlpGrid";
import { useGridColumns } from "../../hooks/useGridColumns";

interface Props {
	filters: PreEnrollmentValidationFilter;
	setFilters: (filters: PreEnrollmentValidationFilter) => void;
	isAdmin?: boolean;
}

export function PreEnrollmentValidationGrid(props: Props) {
	const { columns, isLoading: isLoadingColumns } = useGridColumns(
		"PreEnrollmentValidation",
		PreEnrollmentValidationApi.getGridColumns,
	);

	const validationsQuery = useQuery({
		queryKey: ["PreEnrollmentValidations", props.filters],
		queryFn: () => PreEnrollmentValidationApi.getValidations(props.filters),
	});

	if (isLoadingColumns) return null;

	return (
		<>
			<TLPGrid<PreEnrollmentValidationError, PreEnrollmentValidationFilter>
				id="preEnrollmentValidationsGrid"
				title="Pre Enrollment Validations"
				gridNameForExport="PreEnrollmentValidations"
				pageSizes={[20, 50, 100]}
				keyProperty="id"
				filters={props.filters}
				setFilters={props.setFilters}
				query={validationsQuery}
				columns={columns}
				apiRoute={controller}
				gridApi={PreEnrollmentValidationApi}
				exportFunc={PreEnrollmentValidationApi.getValidations}
				maxHeight="100vh"
			/>
		</>
	);
}
